import React, { useState } from 'react';

export const BilingualFlyer = ({ imageEn, imageEs, alt }) => {
  const [lang, setLang] = useState('en');
  return (
    <div className="relative w-full h-full bg-[#15304e]">
      <img
        src={lang === 'en' ? imageEn : imageEs}
        alt={lang === 'en' ? alt : `${alt} (Español)`}
        className="w-full h-full object-contain"
      />
      <div className="absolute bottom-3 right-3 flex rounded-full overflow-hidden shadow-lg border border-white/30" role="group" aria-label="Flyer language">
        <button
          type="button"
          onClick={(e) => { e.preventDefault(); setLang('en'); }}
          aria-pressed={lang === 'en'}
          data-testid="flyer-lang-en"
          className={`px-3 py-1 text-xs font-bold transition-colors ${lang === 'en' ? 'bg-amber-400 text-slate-900' : 'bg-slate-900/80 text-white hover:bg-slate-800'}`}
        >
          English
        </button>
        <button
          type="button"
          onClick={(e) => { e.preventDefault(); setLang('es'); }}
          aria-pressed={lang === 'es'}
          data-testid="flyer-lang-es"
          className={`px-3 py-1 text-xs font-bold transition-colors ${lang === 'es' ? 'bg-amber-400 text-slate-900' : 'bg-slate-900/80 text-white hover:bg-slate-800'}`}
        >
          Español
        </button>
      </div>
    </div>
  );
};
